module.exports = __webpack_public_path__ + "img/1p9xCzfcN2RPm-0lyXYsy56YN3R3N4bDP.79bfea46.png";